import { mapSliderResponse } from "../utils/mappers";
import type { Image } from "./image.type";

export interface CssColors {
  id: number;
  documentId: string;
  backgroundColor: string;
  primaryColor: string;
  titleColor: string;
  subtitleColor: string;
  paragraphColor: string;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
  logo: Image;
  logoFooter: Image;
}

export enum CssColorKeys {
  HTML_BACKGROUND = "html-background-color",
  TITLE_TEXT = "text-title-color",
  SUBTITLE_TEXT = "text-subtitle-color",
  PARAGRAPH_TEXT = "text-paragraph-color",
  PRIMARY_COLOR = "primary-color",
}

export const mapCssColorsResponse = (data: CssColors): Record<CssColorKeys, string> => {
  return {
    [CssColorKeys.HTML_BACKGROUND]: data.backgroundColor,
    [CssColorKeys.TITLE_TEXT]: data.titleColor,
    [CssColorKeys.PRIMARY_COLOR]: data.primaryColor,
    [CssColorKeys.SUBTITLE_TEXT]: data.subtitleColor,
    [CssColorKeys.PARAGRAPH_TEXT]: data.paragraphColor,
  };
};